export default __webpack_public_path__ + "static/media/nour.c7a39203.webp";